import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  models: { id: string; name: string }[];
  value: string;
  onChange: (id: string) => void;
}

const ModelSelect: React.FC<Props> = ({ models, value, onChange }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const filtered = useMemo(
    () =>
      models
        .filter((m) => m.id.toLowerCase().includes(query.toLowerCase()))
        .slice(0, 50),
    [models, query]
  );
  return (
    <div className="relative">
      <input
        value={open ? query : value}
        placeholder={t('critics.search_models')}
        onFocus={() => {
          setOpen(true);
          setQuery('');
        }}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onChange={(e) => setQuery(e.target.value)}
        className="w-full p-2 border rounded-md font-mono text-sm"
      />
      {open && (
        <ul className="absolute z-10 w-full max-h-64 overflow-y-auto bg-white border rounded-md mt-1 shadow-lg">
          {filtered.map((m) => (
            <li key={m.id}>
              <button
                type="button"
                onMouseDown={() => {
                  onChange(m.id);
                  setOpen(false);
                }}
                className="w-full text-left px-3 py-1.5 text-sm hover:bg-blue-50 font-mono"
              >
                {m.id}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ModelSelect;
